import { Box, FormControl, FormHelperText, InputAdornment, OutlinedInput, Typography } from '@mui/material';
import React from 'react';

// @ts-check

/**
 * @param {{
 *   title: string,
 *   unit: string,
 *   prefix?: string | null,
 *   helperText?: string | null,
 *   defaultValue: number | string
 * }} props
 */

const ParameterBox = ({
  title,
  unit,
  prefix,
  helperText,
  defaultValue
}) => {
  return (

    <Box sx={{
      display: "flex",
      flexDirection: "column",
      width: "100%",
      // gap: 1,
      // border: 1,
    }}>
      <Typography sx={{
        paddingLeft: "8px",
        color: "#6F6F6F"
      }}>
        {title}
      </Typography>
      <FormControl sx={{ m: 0, width: "100%" }} variant="outlined">
        <OutlinedInput
          id="outlined-adornment-weight"
          startAdornment={
            prefix && <InputAdornment position="start">
              {prefix}
            </InputAdornment>
          }
          endAdornment={
            <InputAdornment position="end">
              {unit}
            </InputAdornment>
          }
          defaultValue={defaultValue}
        />
        {helperText &&
          <FormHelperText>{helperText}</FormHelperText>
        }
      </FormControl>
    </Box>
  )
}

export default ParameterBox